import { useTranslation } from "react-i18next";

import { ILead } from "../../models/Lead";
import { IVehicle } from "../../models/Vehicle";


export default function VehicleJobsTableCell({ lead, vehicle }: { lead: ILead, vehicle: IVehicle }) {
  const { t } = useTranslation("vehicles");

  return (
    <div className="flex flex-col gap-y-2 text-sm">
      <p className="font-semibold">{t("Jobs: {{jobs}} - Total Parts: {{parts}}", { jobs: vehicle?.jobCount ?? 0, parts: lead?.jobs?.[0]?.jobPartCount ?? 0 })}</p>

      <p className="text-xs">{t("Awaiting Dismantling")}: {lead?.jobs?.[0]?.awaitingDismantlingPartCount ?? 0}</p>
      <p className="text-xs">{t("Sold")}: {vehicle?.soldPartCount ?? 0}</p>
      <p className="text-xs">{t("Available Parts")}: {vehicle?.availablePartCount ?? 0}</p>
    </div>
  )
}
